module.exports = __webpack_public_path__ + "img/TiNPad-方形-Inpillar-方形.6db5734a.svg";